exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".root_2iCEC {\n    width: 100%;\n    border-collapse: collapse;\n    margin: 0;\n    margin-top: 10px;\n    margin-bottom: 10px;\n}\n\n.cell_2cxVt {\n    width: 33%;\n    text-align: center;\n    vertical-align: bottom;\n}\n\n.line_38tgq:first-child .cell_2cxVt {\n    border: 2px solid transparent;\n    border-bottom-color: black;\n}\n\n.box_1_NRi {\n    width: 150px;\n    height: 75px;\n    border: 0px dashed black;\n    margin-left: auto;\n    margin-right: auto;\n    position: relative;\n}\n\n.button_22U0S {\n    width: 60px;\n    height: 30px;\n    position: absolute;\n    background-color: blue;\n    color: white;\n    top: 22px;\n    left: 45px;\n}\n\n.error_2CGY9 {\n    margin-top: 3px;\n    color: red;\n    margin-bottom: 5px;\n}\n\n.verySmall_1y0rv {\n    font-size: 10px;\n}\n\n.cell2_97A3g {\n    width: 90%;\n    text-align: center;\n    vertical-align: bottom;\n}\n\n.cell3_2VoGX {\n    width: 10%;\n    text-align: center;\n    vertical-align: bottom;\n}\n", ""]);

// exports
exports.locals = {
	"root": "root_2iCEC",
	"cell": "cell_2cxVt",
	"line": "line_38tgq",
	"box": "box_1_NRi",
	"button": "button_22U0S",
	"error": "error_2CGY9",
	"verySmall": "verySmall_1y0rv",
	"cell2": "cell2_97A3g",
	"cell3": "cell3_2VoGX"
};